import React from "react";
import renderHTML from "react-render-html";
import { sanitizeHtml } from "../Experience/sanitize";
import { looksLikeHtml } from "./richTextHelpers";
import "./RichTextContent.css";

export { looksLikeHtml, plainTextFromHtml } from "./richTextHelpers";

/**
 * Shared rich text display (A-007.1).
 * Renders sanitized HTML from the API; plain-text legacy content keeps pre-wrap.
 * Reusable for Organizations, Community, Projects, Shop, and Cast & Crew.
 */
function RichTextContent({ html, className }) {
  if (html === null || html === undefined || html === "") {
    return null;
  }

  const content = String(html);
  const classes = ["rich-text", className].filter(Boolean).join(" ");

  if (!looksLikeHtml(content)) {
    return (
      <div className={`${classes} rich-text--plain`.trim()}>{content}</div>
    );
  }

  return <div className={classes}>{renderHTML(sanitizeHtml(content))}</div>;
}

export default RichTextContent;
